import React from 'react'
import moment from 'moment'
import Icon from 'react-icons-kit'
import { calendar } from 'react-icons-kit/fa'

const defaultFormatDateTime = 'DD/MM/YYYY HH:mm'

const renderDateTime = ({ dateFormat = defaultFormatDateTime, value }) => {
  return value ? value.format(dateFormat) : moment().format(dateFormat)
}

const InputDateTime = ({ showModal, value, dateFormat }) => (
  <div className="field has-addons" onClick={showModal}>
    <div className="control input">{renderDateTime({ value, dateFormat })}</div>
    <div className="control">
      <a className="button">
        <span className="icon is-small">
          <Icon icon={calendar} />
        </span>
      </a>
    </div>
  </div>
)

export default InputDateTime



// WEBPACK FOOTER //
// ./src/modules/calendar/InputDateTime.js